import React from "react";
import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [error, setError] = React.useState(null);
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const data = {
      email: form.username.value,
      password: form.password.value,
    }
    console.log("Form data:", data);

    fetch("https://e-swaap-api.vercel.app/api/v1/admins/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // 👈 absolutely required
      },
      body: JSON.stringify(data), // 👈 must be a valid JSON string
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data?.message);
        if (data?.message === "Invalid email or password combination") {
          // alert("Invalid email or password");
          setError("Invalid email or password");
        } else {
          // alert("Login successful");
          // redirect to admin dashboard
          setError(null);
          navigate("/admin/dashboard");
        }
      })
      .catch((error) => {
        console.error("Login failed:", error);
      });

    // form.reset();
  };
  return (
    <div className="py-32 min-h-[calc(100vh-72px)] flex justify-center items-center bg-gray-100">
      <div className="container mx-auto">
        <div className="w-96 mx-auto bg-white p-8 rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-center mb-8">Admin Login</h1>
          <form id="login-form" onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Username
              </label>
              <input
                type="text"
                required
                name="username"
                id="username"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Password
              </label>
              <input
                type="password"
                required
                name="password"
                id="password"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            {error && (
              <div className="mb-4 text-red-500 text-sm">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="w-full bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
